import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { CREATE_ASYNC_JOB } from '../types';
import {
  createAsyncJobPending } from '../actions';

import { sendApiRequest, notifyError, notifySuccess } from '../../../actions';


import { CREATE_ASYNC_JOB_MESSAGES } from '../constants/organizationMessages'
import generateError from '../../../utilities/generateError';

const createPayload = (payload) => ({
  method: 'post',
  url: 'asyncjobs/create?jobType='+payload.jobType,
  onSuccess: [
    () => notifySuccess(CREATE_ASYNC_JOB_MESSAGES.SUCCESS)
  ],
  onError: [
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const createAsyncJobEpic$ = (action$, state$) => action$.pipe(
  ofType(CREATE_ASYNC_JOB.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    return merge(
      of(createAsyncJobPending()),
      of(sendApiRequest(createPayload(payload), meta)),
    );
  }),
);

export default createAsyncJobEpic$;


// WEBPACK FOOTER //
// ./src/features/organization/epics/createAsyncJobEpic.js